import atoms from "../../../../atoms";
import AddStorePermission from "./AddStorePermision";
import { TPermissionStep } from "./interface";

const { Select } = atoms;

const PermissionStep = ({
  rolesList,
  defaultPermission,
  structuredPermission,
  setStoreDetails,
  setDefaultPermission,
  handleSelectedRole,
  selectedRole,
}: TPermissionStep) => {
  return (
    <div>
      <div className="row mb-4">
        <div className="col-4">
          <Select
            type={"text"}
            className={"w-100"}
            options={rolesList}
            value={selectedRole}
            onChange={(e:React.MouseEvent<HTMLDivElement>) => handleSelectedRole(e)}
            placeholder={"Select"}
            label={"Select Role"}
          />
        </div>
        <div className="col-8"></div>
      </div>
      <div>
        <AddStorePermission
          defaultPermission={defaultPermission}
          structuredPermission={structuredPermission}
          setStoreDetails={setStoreDetails}
          setDefaultPermission={setDefaultPermission}
          permissionKey="admin_permissions"
        />
      </div>
    </div>
  );
};

export default PermissionStep;
